import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('modules.ProfileModule.TrialPeriodStartedPopup', {
    successMessage: 'Your all features trial period has started',
    close: 'Close',
});
